import { OfferStatus } from '@recruitee/offers-types';

export const getJobRouterLink = ({
  status,
  slug,
}: {
  status: OfferStatus;
  slug: string;
}): string[] => {
  if (status === OfferStatus.Draft) {
    return ['/offers', slug, 'edit'];
  }

  return ['/offers', slug, 'pipeline'];
};
